// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__ci8ty","list":"PatternAutocomplete_list__19_73"};